export const UPDATE_CONVERSATION = (state, data) => {
   state.conversation.push(data);
}

